<template>
    <div id="form-container" ref="formContainer">
        <b-container fluid>
        <h1>
            Update Contact Information
        </h1>
            <b-form class="mt-3">
                <b-row>
                    <b-col cols="6">
                        <BaseMaskedTextInput v-model="update.phone"
                                             :v="$v.update.phone"
                                             slug="phone"
                                             label="Cell Phone Number"
                                             setId="phone"
                                             mask="(###)###-####"
                        />
                    </b-col>
                    <b-col cols="6">
                        <BaseTextInput v-model="update.email"
                                       :v="$v.update.email"
                                       slug="email"
                                       label="Email"
                        />
                    </b-col>
                </b-row>
                <b-row>
                    <b-col cols="8">
                        <BaseTextInput v-model="update.address.streetAddress"
                                       :v="$v.update.address.streetAddress"
                                       slug="streetAddress"
                                       label="Street Address"
                                       tip="Please include apartment number or PO Box number if relevant."
                        />
                    </b-col>
                </b-row>
                <b-row>
                    <b-col cols="4">
                        <BaseTextInput v-model="update.address.city"
                                       :v="$v.update.address.city"
                                       slug="city"
                                       label="City"
                        />
                    </b-col>
                    <b-col cols="4">
                        <BaseSelector v-model="update.address.state"
                                      :v="$v.update.address.state"
                                      label="State"
                                      slug="state"
                                      :options=opts.stateOptions
                        />
                    </b-col>
                    <b-col cols="4">
                        <BaseMaskedTextInput v-model="update.address.postalCode"
                                             :v="$v.update.address.postalCode"
                                             slug="postalCode"
                                             label="ZIP"
                                             mask="#####-####"
                        />
                    </b-col>
                </b-row>
                <b-row>
                    <b-col cols="2">
                        <b-button type="button" variant="primary" @click="updateContact">Update</b-button>
                    </b-col>
                </b-row>
            </b-form>
        </b-container>
    </div>
</template>

<script>
import axios from "axios"
import axiosRetry from 'axios-retry'
import { required, minLength, maxLength, email } from 'vuelidate/lib/validators'
import {toastService} from "@/mixins/toastService";
import {commonOptions} from "@/mixins/commonOptions";

axiosRetry(axios, { retries: 0,
    retryDelay: axiosRetry.exponentialDelay  })

export default {
    data: () => ({
        update: {
            phone: null,
            email: null,
            address: {
                streetAddress: null,
                city: null,
                state: null,
                postalCode: null,
            }
        },
    }),
    validations() {
        return {
            update: {
                address: {
                    streetAddress: { required },
                    city: { required },
                    state: { required },
                    postalCode: { required,
                        maxLength: maxLength(10),
                        minLength: minLength(5) },
                },
                phone: { required,
                    minLength: minLength(13),
                    maxLength: maxLength(13) },
                email: { required, email },
            }
        }
    },
    methods: {
        initialize() {
            axios.get(`${process.env.VUE_APP_API_BASE_URL}/profile/user`)
                .then(response => {
                    this.update = response.data.contact
                })
        },
        updateContact() {
            this.$v.$touch();
            if (!this.$v.$invalid) {
                axios.post(`${process.env.VUE_APP_API_BASE_URL}/profile/contact/`, this.update)
                    .then(response => {
                        toastService.showRootToast("Contact Information Update", "Your contact information has been updated.", "success", this.$root)
                    }) .catch(error => {
                    console.log(error)
                    toastService.showRootToast("Error", "An error has occurred " , "danger", this.$root)
                })
            }
        }
    },
    created() {
        this.initialize()
        document.title = "Update Contact Information - NAR"
    },
    mixins: [
        toastService,
        commonOptions
    ],
}
</script>
<style>
    .paCol { width: 15%; }
</style>